export const DEFAULT_SUB_MAX_RETRIES = 5
export const DEFAULT_SUB_BASE_DELAY_MS = 2000
export const DEFAULT_SUB_MAX_DELAY_MS = 10000

export interface GqlSubOptions {
  dataDomain?: string
  // number of resubscribe attempts after a failure before giving up; 0 disables retry
  maxRetries?: number
  baseDelayMs?: number
  maxDelayMs?: number
  // called once, after the last retry attempt has failed
  onRetriesExhausted?: () => void
}

export interface GqlSubscriptionHandle {
  unsubscribe: () => void
}

// attempt is 1-based; mirrors the previous dashboard formula Math.min(2000 * attempt, 10000)
export function nextSubscriptionRetryDelayMs (
  attempt: number,
  baseDelayMs = DEFAULT_SUB_BASE_DELAY_MS,
  maxDelayMs = DEFAULT_SUB_MAX_DELAY_MS
): number {
  return Math.min(baseDelayMs * Math.max(attempt, 1), maxDelayMs)
}
